"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Second = exports.Mole = exports.Meter = exports.Kilogram = exports.Kelvin = exports.Candela = exports.Ampere = void 0;
var uom_1 = require("uom");
exports.Ampere = uom_1.UnitFormat.createUnitFormat("A", 2);
exports.Candela = uom_1.UnitFormat.createUnitFormat("cd", 0);
exports.Kelvin = uom_1.UnitFormat.createUnitFormat("K", 2);
exports.Kilogram = uom_1.UnitFormat.createUnitFormat("kg", 2);
exports.Meter = uom_1.UnitFormat.createUnitFormat("m", 2);
exports.Mole = uom_1.UnitFormat.createUnitFormat("mol", 2);
exports.Second = uom_1.UnitFormat.createUnitFormat("s", 2);
//# sourceMappingURL=base-units-format.js.map